var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShapeBottomLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 346,
  height: 480,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeOpacity: 0.2,
  strokeWidth: 2.099,
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__a)",
  d: "M189.375 234.671c9.228 4.013 14.17 11.499 12.965 19.639l-21.403 144.574c-1.204 8.14-8.375 15.697-18.808 19.825l-185.308 73.315c-10.433 4.128-22.546 4.199-31.775.187l-163.905-71.259c-9.228-4.012-14.17-11.499-12.965-19.639l21.403-144.574c1.204-8.14 8.375-15.697 18.808-19.825l185.308-73.315c10.433-4.128 22.546-4.199 31.775-.187z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__b)",
  d: "M176.377 234.433c9.027 3.592 14.113 10.587 13.341 18.35l-13.701 137.879c-.771 7.763-7.283 15.115-17.082 19.287L-15.101 484.04c-9.799 4.171-21.397 4.529-30.425.937l-160.335-63.788c-9.027-3.591-14.113-10.586-13.341-18.349l13.701-137.879c.771-7.763 7.283-15.115 17.081-19.287l174.037-74.091c9.798-4.171 21.397-4.529 30.425-.938z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__c)",
  d: "M163.509 234.73c8.794 3.189 13.982 9.699 13.609 17.077l-6.624 131.036c-.372 7.377-6.251 14.502-15.418 18.691L-7.759 475.923c-9.167 4.189-20.234 4.804-29.03 1.615l-156.21-56.646c-8.794-3.189-13.982-9.699-13.609-17.077l6.624-131.036c.372-7.377 6.251-14.502 15.418-18.691l162.835-74.389c9.167-4.189 20.234-4.804 29.03-1.615z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__d)",
  d: "M150.814 235.55c8.532 2.807 13.783 8.839 13.772 15.825l-.182 124.068c-.009 6.985-5.279 13.863-13.822 18.042L-1.153 467.704c-8.543 4.179-19.063 5.025-27.596 2.218l-151.553-49.848c-8.532-2.807-13.783-8.84-13.772-15.825l.182-124.069c.009-6.985 5.279-13.863 13.822-18.041l151.735-74.22c8.543-4.179 19.063-5.024 27.596-2.218z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__e)",
  d: "M138.326 236.88c8.241 2.444 13.514 8.008 13.829 14.596l5.617 117.002c.317 6.587-4.371 13.198-12.297 17.341L4.704 459.41c-7.926 4.143-17.887 5.19-26.13 2.746l-146.388-43.411c-8.242-2.445-13.514-8.009-13.83-14.597l-5.617-117.001c-.317-6.587 4.371-13.198 12.297-17.342l140.772-73.59c7.926-4.143 17.886-5.19 26.129-2.746z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__f)",
  d: "M126.082 238.704c7.924 2.104 13.179 7.209 13.785 13.395l10.766 109.86c.607 6.185-3.528 12.511-10.846 16.594L9.809 451.065c-7.318 4.082-16.708 5.302-24.633 3.2l-140.744-37.348c-7.924-2.103-13.179-7.209-13.784-13.394l-10.767-109.86c-.607-6.185 3.529-12.511 10.847-16.594l129.977-72.512c7.318-4.083 16.708-5.303 24.633-3.2z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__g)",
  d: "M114.114 241.012c7.58 1.783 12.78 6.443 13.639 12.224l15.261 102.667c.859 5.78-2.753 11.804-9.474 15.801L14.156 442.701c-6.722 3.998-15.533 5.362-23.114 3.579l-134.645-31.671c-7.581-1.783-12.78-6.443-13.639-12.223l-15.261-102.668c-.86-5.78 2.752-11.804 9.474-15.801l119.384-70.997c6.721-3.997 15.533-5.362 23.114-3.579z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__h)",
  d: "M102.459 243.786c7.214 1.486 12.32 5.713 13.395 11.087l19.097 95.449c1.075 5.374-2.044 11.08-8.182 14.968L17.746 434.347c-6.138 3.888-14.364 5.368-21.578 3.882l-128.119-26.392c-7.213-1.487-12.319-5.713-13.394-11.087l-19.097-95.45c-1.076-5.373 2.043-11.08 8.182-14.968l109.022-69.056c6.138-3.888 14.364-5.368 21.578-3.883z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__i)",
  d: "M91.154 247.008c6.823 1.212 11.799 5.019 13.053 9.987l22.273 88.229c1.254 4.967-1.405 10.341-6.974 14.097l-98.924 66.705c-5.57 3.756-13.205 5.323-20.029 4.111l-121.197-21.524c-6.823-1.212-11.799-5.019-13.053-9.987l-22.272-88.229c-1.255-4.968 1.404-10.342 6.974-14.097l98.924-66.706c5.57-3.755 13.204-5.322 20.028-4.111z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__j)",
  d: "M80.224 250.662c6.413.962 11.224 4.365 12.619 8.928l24.787 81.032c1.397 4.562-.835 9.591-5.852 13.192L22.66 417.77c-5.018 3.601-12.06 5.227-18.473 4.266L-109.72 404.96c-6.412-.962-11.223-4.365-12.618-8.927L-147.125 315c-1.396-4.562.836-9.591 5.853-13.192l89.118-63.956c5.017-3.601 12.06-5.227 18.473-4.266z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__k)",
  d: "M69.71 254.728c5.984.736 10.594 3.751 12.094 7.911l26.643 73.882c1.5 4.159-.338 8.832-4.821 12.256l-79.633 60.825c-4.484 3.425-10.932 5.082-16.916 4.347L-99.2 400.893c-5.983-.735-10.594-3.751-12.093-7.911l-26.643-73.881c-1.501-4.16.337-8.832 4.821-12.257l79.633-60.825c4.483-3.425 10.932-5.082 16.915-4.347z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__l)",
  d: "M59.636 259.189c5.536.534 9.913 3.179 11.48 6.941l27.842 66.801c1.568 3.761.088 8.066-3.881 11.294l-70.498 57.328c-3.969 3.228-9.825 4.888-15.362 4.355l-98.339-9.473c-5.536-.534-9.913-3.179-11.48-6.941l-27.842-66.801c-1.568-3.761-.088-8.066 3.881-11.294l70.497-57.328c3.97-3.228 9.826-4.888 15.363-4.355z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__m)",
  d: "M50.029 264.021c5.074.356 9.185 2.651 10.783 6.019L89.2 329.854c1.598 3.368.441 7.298-3.035 10.309l-61.738 53.482c-3.476 3.011-8.743 4.646-13.818 4.29l-90.126-6.333c-5.074-.357-9.184-2.651-10.783-6.019l-28.387-59.814c-1.599-3.368-.442-7.298 3.034-10.309l61.738-53.482c3.476-3.011 8.743-4.647 13.818-4.29z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__n)",
  d: "M40.918 269.203c4.598.206 8.412 2.168 10.004 5.15l28.288 52.945c1.593 2.981.722 6.527-2.283 9.303l-53.381 49.304c-3.006 2.776-7.69 4.36-12.289 4.155l-81.668-3.641c-4.598-.205-8.412-2.168-10.005-5.149l-28.287-52.946c-1.593-2.98-.723-6.527 2.283-9.303l53.381-49.304c3.006-2.776 7.69-4.36 12.288-4.155z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__o)",
  d: "M32.338 274.715c4.11.079 7.597 1.731 9.148 4.333l27.548 46.216c1.551 2.602.93 5.76-1.629 8.283l-45.452 44.812c-2.559 2.523-6.667 4.029-10.778 3.95l-73-1.403c-4.11-.08-7.596-1.731-9.147-4.333l-27.548-46.216c-1.552-2.602-.93-5.76 1.629-8.283l45.451-44.812c2.56-2.523 6.668-4.029 10.778-3.95z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__p)",
  d: "M24.3 280.535c3.613-.021 6.746 1.341 8.22 3.573l26.177 39.649c1.474 2.233 1.065 4.996-1.073 7.25l-37.973 40.027c-2.138 2.253-5.68 3.655-9.292 3.676l-64.152.378c-3.611.021-6.745-1.341-8.218-3.574l-26.178-39.649c-1.475-2.232-1.065-4.996 1.073-7.249l37.973-40.027c2.138-2.254 5.68-3.655 9.292-3.677z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__q)",
  d: "M16.842 286.636c3.105-.095 5.857 1 7.219 2.873l24.188 33.266c1.362 1.873 1.127 4.24-.616 6.208l-30.969 34.966c-1.744 1.969-4.731 3.241-7.837 3.337l-55.157 1.699c-3.105.096-5.857-.999-7.219-2.872l-24.188-33.267c-1.363-1.873-1.127-4.239.616-6.208l30.969-34.966c1.744-1.968 4.731-3.24 7.837-3.336z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__r)",
  d: "M9.977 292.997c2.593-.144 4.939.707 6.154 2.232l21.591 27.09c1.216 1.525 1.117 3.493-.26 5.162l-24.46 29.651c-1.377 1.669-3.822 2.787-6.415 2.931l-46.05 2.561c-2.593.144-4.94-.707-6.155-2.232l-21.59-27.09c-1.216-1.525-1.117-3.493.26-5.162l24.46-29.651c1.377-1.669 3.822-2.786 6.415-2.931z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__s)",
  d: "M3.728 299.594c2.076-.167 3.993.464 5.028 1.654l18.4 21.139c1.035 1.19 1.033 2.76-.007 4.117L8.684 350.605c-1.04 1.357-2.959 2.296-5.034 2.462l-36.864 2.963c-2.076.166-3.992-.464-5.028-1.654l-18.4-21.139c-1.035-1.191-1.033-2.76.007-4.117l18.465-24.101c1.04-1.357 2.959-2.296 5.034-2.463z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__t)",
  d: "M-1.887 306.397c1.556-.163 3.022.271 3.845 1.14l14.627 15.436c.824.869.88 2.041.148 3.073l-13.006 18.34c-.732 1.032-2.141 1.769-3.697 1.933l-27.632 2.904c-1.556.163-3.022-.271-3.845-1.141l-14.627-15.435c-.824-.869-.88-2.041-.148-3.073l13.006-18.34c.732-1.033 2.142-1.77 3.697-1.933z",
  opacity: 0.73
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#shapeBottomLeft_svg__u)",
  d: "M-6.847 313.386c1.036-.134 2.03.13 2.61.693l10.29 9.999c.58.563.656 1.339.2 2.037l-8.097 12.387c-.456.698-1.374 1.21-2.41 1.345l-18.388 2.388c-1.035.135-2.03-.129-2.61-.692l-10.29-9.999c-.58-.563-.656-1.34-.2-2.037l8.097-12.387c.456-.698 1.375-1.21 2.41-1.345z",
  opacity: 0.73
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__a",
  x1: 8537.28,
  x2: -29145.3,
  y1: 12870.9,
  y2: 37750.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__b",
  x1: 8765.99,
  x2: -25750.6,
  y1: 12041.1,
  y2: 37138.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__c",
  x1: 8925.7,
  x2: -22522.9,
  y1: 11222.5,
  y2: 36287.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__d",
  x1: 9017.29,
  x2: -19480.2,
  y1: 10417.4,
  y2: 35220.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__e",
  x1: 9041.76,
  x2: -16636.8,
  y1: 9628.03,
  y2: 33960.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__f",
  x1: 9000.26,
  x2: -14003,
  y1: 8856.66,
  y2: 32532.3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__g",
  x1: 8894.12,
  x2: -11585.9,
  y1: 8105.47,
  y2: 30958.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__h",
  x1: 8724.78,
  x2: -9389.24,
  y1: 7376.59,
  y2: 29263,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__i",
  x1: 8493.84,
  x2: -7414.03,
  y1: 6672.06,
  y2: 27466.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__j",
  x1: 8203.04,
  x2: -5658.96,
  y1: 5993.87,
  y2: 25590.2,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__k",
  x1: 7854.23,
  x2: -4120.72,
  y1: 5343.93,
  y2: 23652.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__l",
  x1: 7449.41,
  x2: -2794.4,
  y1: 4724.07,
  y2: 21670.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__m",
  x1: 6990.71,
  x2: -1673.81,
  y1: 4136.04,
  y2: 19659.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__n",
  x1: 6480.34,
  x2: -751.826,
  y1: 3581.5,
  y2: 17634.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__o",
  x1: 5920.68,
  x2: -20.59,
  y1: 3062.05,
  y2: 15606.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__p",
  x1: 5314.19,
  x2: 528.204,
  y1: 2579.16,
  y2: 13587.6,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__q",
  x1: 4663.45,
  x2: 903.162,
  y1: 2134.24,
  y2: 11586,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__r",
  x1: 3971.1,
  x2: 1112.99,
  y1: 1728.59,
  y2: 9610.31,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__s",
  x1: 3239.93,
  x2: 1166.42,
  y1: 1363.4,
  y2: 7667.45,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__t",
  x1: 2472.79,
  x2: 1072.05,
  y1: 1039.78,
  y2: 5763.29,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "shapeBottomLeft_svg__u",
  x1: 1672.61,
  x2: 838.327,
  y1: 758.734,
  y2: 3902.72,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#52B289"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#29FFBF"
})))));
export default SvgShapeBottomLeft;